import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=5560c4fd&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"
import style0 from "./CatalogList.vue?vue&type=style&index=0&id=5560c4fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560c4fd",
  null
  
)

export default component.exports